import request from "@/utils/request";

export function getConfigType() {
    return request({
        url: 'admin/config-types',
        method: 'GET'
    })
}
export function getConfigList(param) {
    return request({
        url: 'admin/config-list',
        method: 'GET',
        params: param
    })
}

export function addConfig(data) {
    return request({
        url: 'admin/config',
        method: 'POST',
        data:data
    })
}

export function editConfig(data,id) {
    return request({
        url: 'admin/config/'+id,
        method: 'PUT',
        data:data
    })
}

export function deleteConfig(id) {
    return request({
        url: 'admin/config/'+id,
        method: 'DELETE',
    })
}

export function setIs_validate(id,is_validate) {
    return request({
        url: 'admin/config/'+id+'/is-validate/'+is_validate,
        method: 'PUT',
    })
}